import React, { useState, useEffect, useRef, memo, useCallback } from 'react';
import './css/banner.scss';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { bannerLocalConstant } from './utils';
import * as bannerUtils from './utils';
import ReactPlayer from 'react-player';
import { useLocation } from 'react-router';
import {
  updateReportData,
  addBannerClickReport,
  hideInterstitialAds,
  enableInterstitialAds,
  showInterstitialAds,
  disableInterstitialAds
} from '../../Store/actions';
import { useInView } from 'react-intersection-observer';
import ImageBannerPlayer from './ImageBannerPlayer';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import queryString from 'query-string';
import useRedirect from '../customHooks/useRedirect';

import AppConfig from '../../config/config';
import packageJson from '../../../package.json';
import { Modal } from 'react-bootstrap';
import { GrClose, MdOutlineArrowRightAlt } from '../icons';
import { isMobileApp } from '../../common/common';

const TARGET_TYPE_FLOATING = 'Floating';
const TARGET_TYPE_FILLER = 'Filler';
const TARGET_TYPE_FIXED = 'Fixed';
const _TARGET_BLANK = '_blank';
const _TARGET_SELF = '_self';
const _TARGET_DOWNLOAD = 'download';
const BANNER_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/**
 * @param {string} position of banner Item
 * @param {string} name of the page
 * @param {string} className of banner Item Parent
 * @return {jsx} banner creative to show
 */

let temp_creative_id = 0;
const api_url = AppConfig.apiLoc;
var appVersion = packageJson.version;
let campaign_view_counter = 0;
const getLocalStorage = (key, defaultValue) => {
  const prodMode = AppConfig.is_production_build;
  let local_data = localStorage.getItem(
    `${prodMode ? '@ClirnetStore_prod' : '@ClirnetStore_dev'}_${key}`
  );
  if (local_data) {
    return local_data;
  } else {
    return defaultValue;
  }
};
const BannerItem = ({ position = `interstitial`, page_name = '', customClass = '' }) => {
  const topBannerPlayerRef = useRef(null);
  // const topBannerContainer = useRef();
  // const navigate = useNavigate();
  const _playing_item_ref = useRef([]);
  const _playing_index_ref = useRef(-1);
  const _video_duration_ref = useRef(0);
  const { redirectTo } = useRedirect();

  const { search } = useLocation();
  const { id } = queryString.parse(search);
  const [content_id, set_content_id] = useState(id ?? 0);
  const [type, set_type] = useState(page_name ? page_name : '');
  const [top_banner_playing_index, set_top_banner_playing_index] = useState(-1);
  const [top_banner_playing_item, set_top_banner_playing_item] = useState([]);
  const [platform_name, set_platform_name] = useState(bannerUtils.getPlatForm());
  const [banner_user, set_banner_user] = useState(
    JSON.parse(getLocalStorage('user', '{}'))?.user_master_id
  );
  const [top_banner_data, set_top_banner_data] = useState([]);
  const [separate_data, set_separate_data] = useState({});
  const [reRender, setReRender] = useState(true);
  const [banner_play_data, set_banner_play_data] = useState([]);
  const [banner_position, set_banner_position] = useState(`interstitial`);

  const [video_duration, set_video_duration] = useState('');
  const [is_banner_allowed, set_is_banner_allowed] = useState(false);
  const [banner_setting, set_banner_setting] = useState('0x0');
  const [window_width, setWindowWidth] = useState(window.innerWidth ?? 0);
  const [showContinueBtn, setshowContinueBtn] = useState(false);
  const [isCampaignAvailable, setIsCampaignAvailable] = useState(false);
  const [showCloseBtn, setShowCloseBtn] = useState(false);

  let videoPlay = false;
  const dispatch = useDispatch();

  let options = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0
  };

  const handleDuration = (e) => {
    set_video_duration(e);
    console.log('image duration ' + e);
    _video_duration_ref.current = e;
  };

  // const { inViewport } = useInViewport(topBannerContainer, options);
  const [topBannerContainer, inView] = useInView({
    fallbackInView: false,
    threshold: 0
  });

  let visibilityChange = typeof document.hidden
    ? 'visibilitychange'
    : typeof document.msHidden
      ? 'msvisibilitychange'
      : typeof document.webkitHidden
        ? 'webkitvisibilitychange'
        : 'visibilitychange';
  //visibility change synthetic

  // geting platform list data from redux store
  let global_banner_main_data = useSelector((state) => state.banner.banner_data);

  let content_fetch_status = useSelector((state) => state.banner.content_data_get);

  // geting exclude data from redux store
  let banner_exclution_list = useSelector((state) => state.banner.banner_exclution_list);

  // geting content banner data from redux store
  let content_banner_main_data = useSelector((state) => state.banner.content_banner_data);

  // geting banner settings data from redux store
  let banner_settings_data = useSelector((state) => state.banner.banner_settings);

  let show_ads = useSelector((state) => state.banner.is_interstitial_ads_show);

  let is_eligible = useSelector((state) => state.banner.is_interstitial_ads_eligible);

  // // ----------------------------
  if (inView) {
    console.log('in view if' + inView);
    videoPlay = true;
  } else {
    console.log('in view else' + inView);
    videoPlay = false;
  }
  // ----------------------------

  function addPartialView() {
    if (document.visibilityState === 'hidden') {
      recordAnalytics(
        visibilityChange,
        _playing_item_ref.current,
        _playing_index_ref.current,
        _video_duration_ref.current
      );
    }
  }

  // visibility change observer
  useEffect(() => {
    document.addEventListener(visibilityChange, addPartialView);
    return () => {
      dispatch(enableInterstitialAds());

      recordAnalytics(
        'unmount',
        _playing_item_ref.current,
        _playing_index_ref.current,
        _video_duration_ref.current
      );
      document.removeEventListener(visibilityChange, addPartialView);
    };
  }, []);

  useEffect(() => {
    if (
      banner_setting &&
      is_banner_allowed &&
      top_banner_playing_index >= 0 &&
      top_banner_playing_item?.length > 0
    ) {
      setIsCampaignAvailable(true);
    } else {
      setIsCampaignAvailable(false);
    }
  }, [banner_setting, is_banner_allowed, top_banner_playing_index, top_banner_playing_item]);

  useEffect(() => {
    // let skipBtnTimer = '';
    console.log(
      'skip::',
      campaign_view_counter,

      top_banner_playing_item?.length,
      top_banner_playing_index,
      top_banner_playing_item[top_banner_playing_index]?.isSkipButton,
      top_banner_playing_item[top_banner_playing_index]?.ad_skip_time
    );
    console.log(
      `skip:: conditions ${top_banner_playing_item[top_banner_playing_index]?.isSkipButton == 'false'
      } ::
      ${top_banner_playing_item[top_banner_playing_index]?.ad_skip_time > 0}`
    );
    if (
      campaign_view_counter == 0 &&
      top_banner_playing_item?.length > 0 &&
      top_banner_playing_index >= 0 &&
      top_banner_playing_item[top_banner_playing_index]?.isSkipButton == 'true' &&
      top_banner_playing_item[top_banner_playing_index]?.ad_skip_time > 0
    ) {
      let skipBtnTimer = setTimeout(() => {
        console.log(
          'skip:: btn check first ',
          top_banner_playing_item[top_banner_playing_index]?.isSkipButton,
          top_banner_playing_item[top_banner_playing_index]?.ad_skip_time
        );
        setshowContinueBtn(true);
        setShowCloseBtn(false);
      }, top_banner_playing_item[top_banner_playing_index]?.ad_skip_time * 1000);
    } else if (
      campaign_view_counter == 0 &&
      top_banner_playing_item?.length > 0 &&
      top_banner_playing_index >= 0 &&
      top_banner_playing_item[top_banner_playing_index]?.isSkipButton == 'false' &&
      top_banner_playing_item[top_banner_playing_index]?.ad_skip_time <= 0
    ) {
      let skipBtnTimer = setTimeout(() => {
        console.log(
          'skip:: btn check second ',
          top_banner_playing_item[top_banner_playing_index]?.isSkipButton,
          top_banner_playing_item[top_banner_playing_index]?.ad_skip_time
        );
        setShowCloseBtn(true);
        setshowContinueBtn(false);
      }, top_banner_playing_item[top_banner_playing_index]?.ad_skip_time * 1000);
    }

    // return () => {
    //   if (skipBtnTimer) {
    //     clearTimeout(skipBtnTimer);
    //   }
    // };
  }, [top_banner_playing_item, top_banner_playing_index, campaign_view_counter]);

  // useEffect(() => {
  //   if (position) {
  //     console.log('Banner rendering position:::::::' + position);
  //     set_banner_position(position);
  //   }
  // }, [position]);

  // banner exclution data observer
  useEffect(() => {
    console.log('Banner rendering banner_exclution_list:::::::' + position);

    if (
      content_id &&
      content_id != 0 &&
      banner_exclution_list?.length > 0 &&
      bannerUtils._isContains(banner_exclution_list, 'type', page_name)
    ) {
      let exclutionList = bannerUtils.filterExclutionListByType(banner_exclution_list, page_name);
      // //console.group(`checking exclutionList`)
      // ////console.log(JSON.stringify(exclutionList))
      // //console.groupEnd(`checking exclutionList`)
      if (exclutionList?.length > 0) {
        // ////console.log("exclution length >0")
        let { ids } = exclutionList[0];

        // ////console.log("ids:::" + ids.split(','))
        let excludedIds = ids ? ids.split(',') : [];

        if (excludedIds.includes(content_id)) {
          // ////console.log("exclution id  avalable")
          set_is_banner_allowed(false);
          set_banner_setting('0x0');
        } else {
          // ////console.log("exclution id not available")
          set_is_banner_allowed(true);
        }
      } else {
        // ////console.log("exclution not length >0")
        set_is_banner_allowed(true);
      }
    } else {
      // ////console.log("exclution else")
      set_is_banner_allowed(true);
    }
  }, [banner_exclution_list]);

  // global and content banner data observer effect
  useEffect(() => {
    console.log('Banner rendering data:::::::');

    if (
      content_id &&
      content_id != 0 &&
      content_fetch_status &&
      content_banner_main_data &&
      typeof content_banner_main_data == 'object'
    ) {
      switch (position) {
        case bannerLocalConstant.BANNER_POSITION_INTERSTITIAL:
          if (content_banner_main_data.interstitial_banner_data) {
            set_banner_play_data([
              ...new Set([...content_banner_main_data.interstitial_banner_data])
            ]);
          }
          break;

        default:
          bannerUtils.log('no banner data found ');
          break;
      }
      // break data_extract_condition;
    } else if (
      (!content_id || content_id == 0) &&
      !content_fetch_status &&
      !content_banner_main_data &&
      global_banner_main_data &&
      typeof global_banner_main_data == 'object'
    ) {
      //console.log('--------------------global available ');
      switch (position) {
        case bannerLocalConstant.BANNER_POSITION_INTERSTITIAL:
          if (global_banner_main_data.interstitial_banner_data) {
            set_banner_play_data([
              ...new Set([...global_banner_main_data.interstitial_banner_data])
            ]);
          }
          break;
        default:
          bannerUtils.log('no banner data found ');
          break;
      }
    } else if (
      content_id &&
      content_id != 0 &&
      content_fetch_status &&
      !content_banner_main_data &&
      global_banner_main_data &&
      typeof global_banner_main_data == 'object'
    ) {
      //console.log('--------------------global available ');
      switch (position) {
        case bannerLocalConstant.BANNER_POSITION_INTERSTITIAL:
          if (global_banner_main_data.interstitial_banner_data) {
            set_banner_play_data([
              ...new Set([...global_banner_main_data.interstitial_banner_data])
            ]);
          }
          break;

        default:
          bannerUtils.log('no global banner data found ');
          break;
      }
    } else {
      // set_banner_setting("0x0")
      //console.log('--------------------global not available ');
    }
  }, [global_banner_main_data, content_banner_main_data, content_fetch_status]);

  // banner play data observer
  useEffect(() => {
    console.log(
      'Banner rendering banner_play_databanner_play_data::::::: ' + banner_play_data?.length
    );
    if (banner_play_data?.length > 0) {
      filterBannerData();
    }
  }, [banner_play_data]);

  // banner settings data observer
  useEffect(() => {
    console.log('Banner rendering banner_settings_data::::::: ' + banner_settings_data?.length);
    if (banner_settings_data?.length > 0) {
      setBannerSettings(banner_settings_data, position);
    }
  }, [banner_settings_data, position]);

  const filterJsonByPosition = (data = [], matching_value = '') => {
    return data.filter((x) => {
      return x?.position?.toLowerCase() == matching_value?.toLowerCase() && x?.status === '3';
    });
  };

  const setBannerSettings = (_banner_settings_data, _position) => {
    let temp_banner_settings_data = _banner_settings_data;

    let module_settings = filterJsonByPosition(temp_banner_settings_data, _position);

    if (module_settings?.length > 0) {
      module_settings = bannerUtils.getSettingByModule(module_settings, page_name);
      //console.log('module settings inside:' + module_settings[0]?.mobile + '::' + _position);
      if (isMobile) {
        module_settings?.length > 0 && set_banner_setting(module_settings[0].mobile);
      } else {
        module_settings?.length > 0 && set_banner_setting(module_settings[0].desktop);
      }
    }
    //console.groupEnd('banner settings' + _position);
  };

  function filterBannerData() {
    //console.log('inside filtern json');
    campaign_view_counter = 0;
    if (!banner_position) {
      throw new Error(
        'Banner Item Must Have a valid position (eg: top,side-top,bottom,side-bottom)'
      );
    }
    if (!page_name) {
      throw new Error('Banner Item Must Have a valid page_name');
    }

    let temp_top_banner_data = banner_play_data;

    set_top_banner_data(temp_top_banner_data);
    const temp_banner_data = {
      top_banner_floating_data: [],
      top_banner_filler_data: [],
      top_banner_fixed_data: []
    };

    if (temp_top_banner_data?.length > 0) {
      temp_banner_data.top_banner_floating_data = bannerUtils.filterJsonByTargetType(
        temp_top_banner_data,
        TARGET_TYPE_FLOATING
      );

      temp_banner_data.top_banner_filler_data = bannerUtils.filterJsonByTargetType(
        temp_top_banner_data,
        TARGET_TYPE_FILLER
      );

      if (content_id && content_id != 0) {
        temp_banner_data.top_banner_fixed_data = bannerUtils.filterJsonByTargetType(
          temp_top_banner_data,
          TARGET_TYPE_FIXED
        );
      }

      set_separate_data(temp_banner_data);
    } else {
      bannerUtils.log('no Priority /////////');
    }
    console.log('inside filtern json out' + JSON.stringify(temp_banner_data));
    setPriorityList(temp_banner_data);
  }

  const recordAnalytics = (record_type = '', _item = [], _index = 0, _video_duration = 0) => {
    const temp_session_data = sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA)
      ? JSON.parse(sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA))
      : '';

    if (_item?.length > 0 && _index >= 0 && _video_duration > 0) {
      let temp_reporting_data = '';
      temp_reporting_data = bannerUtils.getBannerReportFormat();
      temp_reporting_data.type = type;
      temp_reporting_data.type_id = content_id;
      temp_reporting_data.banner_user = banner_user;
      temp_reporting_data.timestamp_get =
        temp_session_data && temp_session_data.get_timestamp ? temp_session_data.get_timestamp : 0;
      temp_reporting_data.campaign_id = _item[_index]?.campaign_id ?? '';
      temp_reporting_data.creative_id = temp_creative_id ? temp_creative_id : '';
      temp_reporting_data.position = _item[_index]?.position ?? '';
      temp_reporting_data.os = platform_name;

      const tempCurrentTime = dayjs(new Date()).subtract(_video_duration, 'second');
      temp_reporting_data.start_time = dayjs(tempCurrentTime).format(
        bannerLocalConstant.BANNER_DATE_FORMAT
      );
      temp_reporting_data.end_time = bannerUtils.getCurrentTime();

      // if (_item[_index].items[0].type == 'image' && _index >= 0) {
      //     temp_reporting_data.duration = _video_duration;
      // } else {
      temp_reporting_data.duration = _video_duration;
      // }

      let temp_banner_report = '';
      temp_banner_report = sessionStorage.getItem('banner_report')
        ? JSON.parse(sessionStorage.getItem('banner_report'))
        : '';

      // //console.table(temp_banner_report)
      if (record_type == 'unmount' && temp_banner_report && temp_reporting_data) {
        temp_banner_report = [...temp_banner_report, temp_reporting_data];
        sessionStorage.setItem('banner_report', JSON.stringify(temp_banner_report));
        //console.log('PARTIAL:unmount ' + temp_reporting_data.duration);
      } else if (record_type == visibilityChange && temp_reporting_data) {
        if (
          temp_reporting_data &&
          temp_reporting_data.campaign_id &&
          temp_reporting_data.creative_id
        ) {
          let reporting_array_temp = {};
          reporting_array_temp.data = temp_reporting_data;
          reporting_array_temp.version = isMobileApp() ? `rjsa ${appVersion}` : `rjsw ${appVersion}`;
          reporting_array_temp.os = platform_name;
          reporting_array_temp.token = getLocalStorage('accessToken', '');
          let _data = JSON.stringify(reporting_array_temp);
          navigator.sendBeacon(`${api_url}/openapi/clirbannerBeacone`, _data);
        }
        // //console.log("PARTIAL:visibilityChange " + temp_reporting_data.duration)
      }
    } else {
      ////console.log("inside else")
    }
  };

  function getBannerPlayItem(params_separate_data) {
    let temp_banner_item = [];
    if (params_separate_data.top_banner_fixed_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(params_separate_data.top_banner_fixed_data);
    } else if (params_separate_data.top_banner_floating_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(
        params_separate_data.top_banner_floating_data
      );
    } else if (params_separate_data.top_banner_filler_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(params_separate_data.top_banner_filler_data);
    }
    return temp_banner_item;
  }

  function setPriorityList(params_separate_data) {
    let temp_top_banner_playing_index =
      _playing_index_ref.current >= 0 ? _playing_index_ref.current : -1;
    //console.log('inside set priority' + temp_top_banner_playing_index);
    temp_creative_id = 0;
    let temp_banner_item = [];
    if (params_separate_data.top_banner_fixed_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(params_separate_data.top_banner_fixed_data);
    } else if (params_separate_data.top_banner_floating_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(
        params_separate_data.top_banner_floating_data
      );
    } else if (params_separate_data.top_banner_filler_data?.length > 0) {
      temp_banner_item = bannerUtils.sortByTargeViews(params_separate_data.top_banner_filler_data);
    } else {
    }
    //console.log('<before 0 >' + temp_banner_item?.length);
    if (temp_banner_item && temp_banner_item?.length > 0) {
      /** setting up banner play index start */
      if (temp_top_banner_playing_index == -1) {
        //console.log('inside case 1 ');
        _playing_index_ref.current = 0;
        set_top_banner_playing_index(0);
      } else if (temp_banner_item.length - 1 == temp_top_banner_playing_index) {
        //console.log('inside case 2 ');
        _playing_index_ref.current = 0;
        set_top_banner_playing_index(0);
      } else if (temp_banner_item.length == temp_top_banner_playing_index) {
        //console.log('inside case 3 ');
        _playing_index_ref.current = 0;
        set_top_banner_playing_index(0);
      } else {
        let next_stack = '';
        next_stack = temp_top_banner_playing_index + 1;
        _playing_index_ref.current = temp_top_banner_playing_index + 1;
        //console.log(_playing_index_ref.current + 'inside case else ' + next_stack);
        set_top_banner_playing_index(next_stack);
      }
      /** setting up banner play index end */

      let previous_item_length = temp_banner_item?.length ?? 0;
      let previous_banner_type = temp_banner_item[_playing_index_ref.current]?.target_type ?? '';

      if (
        temp_banner_item?.length > 0 &&
        temp_banner_item[_playing_index_ref.current]?.target_type != TARGET_TYPE_FILLER
      ) {
        let _temp_banner_item = removeElemIfCriteriaMatched(temp_banner_item);

        temp_banner_item = _temp_banner_item;
      }

      //console.log(previous_item_length + '<after1>' + temp_banner_item?.length);

      if (
        previous_banner_type != TARGET_TYPE_FILLER &&
        previous_item_length > 0 &&
        temp_banner_item?.length <= 0
      ) {
        let _separate_data = params_separate_data;
        //console.log('<recursion>');

        if (previous_banner_type == TARGET_TYPE_FIXED) {
          //console.log('fixed ');
          _separate_data.top_banner_fixed_data = temp_banner_item;
        } else if (previous_banner_type == TARGET_TYPE_FLOATING) {
          //console.log('floating ');
          _separate_data.top_banner_floating_data = temp_banner_item;
        } else if (previous_banner_type == TARGET_TYPE_FILLER) {
          //console.log('filler ');
          _separate_data.top_banner_filler_data = temp_banner_item;
        }
        _playing_index_ref.current = -1;
        _playing_item_ref.current = [];
        set_top_banner_playing_index(-1);
        set_top_banner_playing_item([]);

        set_separate_data(_separate_data);
        setPriorityList(_separate_data);
      } else {
        set_top_banner_playing_item([]);
        _playing_item_ref.current = [];
        let isData = '';
        isData = _search(temp_banner_item[_playing_index_ref.current]?.items, banner_setting)[0]
          ?.file;

        if (temp_banner_item?.length > 0 && isData) {
          _playing_item_ref.current = temp_banner_item;

          set_top_banner_playing_item(temp_banner_item);
        } else {
          if (_playing_index_ref.current >= 0) {
            try {
              temp_banner_item.splice(_playing_index_ref.current, 1);
            } catch (error) {
              //console.log('error in banner priority ' + error);
            }
            // temp_banner_item = temp_data_after_removed;

            //console.groupEnd('remove data');
          }

          let _separate_data = params_separate_data;
          //console.log('<recursion else>');

          if (previous_banner_type == TARGET_TYPE_FIXED && temp_banner_item?.length > 0) {
            //console.log('fixed ');
            _separate_data.top_banner_fixed_data = temp_banner_item;
          } else if (previous_banner_type == TARGET_TYPE_FLOATING && temp_banner_item?.length > 0) {
            //console.log('floating ');
            _separate_data.top_banner_floating_data = temp_banner_item;
          } else if (previous_banner_type == TARGET_TYPE_FILLER && temp_banner_item?.length > 0) {
            //console.log('filler ');
            _separate_data.top_banner_filler_data = temp_banner_item;
          }

          if (
            _separate_data?.top_banner_fixed_data?.length > 0 ||
            _separate_data?.top_banner_floating_data?.length > 0 ||
            _separate_data?.top_banner_filler_data?.length > 0
          ) {
            _playing_item_ref.current = [];
            set_top_banner_playing_item([]);
            set_separate_data(_separate_data);
            setPriorityList(_separate_data);
          }
        }
      }

      //  videoPlay = true; test
    } else {
      // set_banner_setting("0x0")
    }
  }

  const removeElemIfCriteriaMatched = (arr = []) => {
    // max_view_per_user_campaign >= max_view_per_campaign ||
    const _index = arr.findIndex(
      ({
        max_view_per_session,
        max_view_per_user_campaign,
        bal_view_per_user_per_camp,
        max_view_per_campaign,
        total_view_done_per_day_campaign,
        view_per_day
      }) => {
        return (
          max_view_per_session <= 0 || bal_view_per_user_per_camp <= 0
          // || total_view_done_per_day_campaign >= view_per_day
        );
      }
    );

    //console.log(arr?.length + 'removedData::' + _index);
    if (_index >= 0) {
      arr.splice(_index, 1);
    }
    let tempArr = [];
    tempArr = removeElemByBannerSettings(arr);
    //console.log('after setting check::' + tempArr?.length);
    return tempArr;
  };

  const removeElemByBannerSettings = (arr = []) => {
    let filtered_arr_data = [];
    arr.map((key, ind) => {
      const { items } = key;
      if (items?.length > 0 && _search(items, banner_setting)?.length > 0) {
        filtered_arr_data.push(key);
      }
    });
    return filtered_arr_data;
  };

  const onImageViewEnd = () => {
    onBannerChange();
  };

  const onBannerChange = () => {
    campaign_view_counter += 1;

    try {
      const temp_session_data = sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA)
        ? JSON.parse(sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA))
        : '';

      const temp_reporting_data = bannerUtils.getBannerReportFormat();
      temp_reporting_data.type = type;
      temp_reporting_data.type_id = content_id ?? 0;
      temp_reporting_data.banner_user = banner_user;
      temp_reporting_data.timestamp_get =
        temp_session_data && temp_session_data.get_timestamp ? temp_session_data.get_timestamp : 0;
      temp_reporting_data.campaign_id =
        top_banner_playing_item[top_banner_playing_index]?.campaign_id ?? '';
      temp_reporting_data.creative_id = temp_creative_id ?? '';
      temp_reporting_data.position =
        top_banner_playing_item[top_banner_playing_index]?.position ?? '';
      temp_reporting_data.os = platform_name;
      const tempCurrentTime = dayjs(new Date()).subtract(_video_duration_ref.current, 'second');
      temp_reporting_data.start_time = dayjs(tempCurrentTime).format(
        bannerLocalConstant.BANNER_DATE_FORMAT
      );
      temp_reporting_data.end_time = bannerUtils.getCurrentTime();
      temp_reporting_data.duration = _video_duration_ref.current;

      // video_duration = 0;
      if (
        temp_reporting_data &&
        temp_reporting_data?.campaign_id &&
        temp_reporting_data?.creative_id
      ) {
        dispatch(updateReportData(temp_reporting_data));
      }

      //bannerUtils.log("end of func......................." + JSON.stringify(temp_reporting_data))
    } catch (error) { }
    if (separate_data.top_banner_fixed_data?.length > 0) {
      calculateMaxViewPerSession(TARGET_TYPE_FIXED);
    } else if (separate_data.top_banner_floating_data?.length > 0) {
      calculateMaxViewPerSession(TARGET_TYPE_FLOATING);
    } else if (separate_data.top_banner_filler_data?.length > 0) {
      calculateMaxViewPerSession(TARGET_TYPE_FILLER);
    } else {
      set_is_banner_allowed(false);
      set_banner_play_data([]);
      bannerUtils.log('no top banner data found /////////' + JSON.stringify(separate_data));
    }
  };

  const calculateMaxViewPerSession = (type = '') => {
    let temp_banner_data = top_banner_playing_item;
    if (top_banner_playing_index >= 0 && temp_banner_data?.length > 0) {
      calculation_condition: if (
        temp_banner_data[top_banner_playing_index]?.target_type == TARGET_TYPE_FILLER
      ) {
        // alert("filler");
        break calculation_condition;
      } else if (
        temp_banner_data[top_banner_playing_index].max_view_per_session &&
        parseInt(temp_banner_data[top_banner_playing_index].max_view_per_session) > 0 &&
        temp_banner_data[top_banner_playing_index].view_per_day &&
        parseInt(temp_banner_data[top_banner_playing_index].view_per_day) > 0
      ) {
        // alert("cal")
        temp_banner_data[top_banner_playing_index].total_view_done_per_day_campaign =
          parseInt(temp_banner_data[top_banner_playing_index].total_view_done_per_day_campaign) + 1;

        //----removed for optimization----//
        // temp_banner_data[top_banner_playing_index].max_view_per_user_campaign =
        //   parseInt(temp_banner_data[top_banner_playing_index].max_view_per_user_campaign) + 1;
        //----optimization----//

        //----added for optimization----//
        temp_banner_data[top_banner_playing_index].bal_view_per_user_per_camp =
          parseInt(temp_banner_data[top_banner_playing_index].bal_view_per_user_per_camp) - 1;
        //----optimization----//

        temp_banner_data[top_banner_playing_index].view_per_day =
          parseInt(temp_banner_data[top_banner_playing_index].view_per_day) - 1;
        temp_banner_data[top_banner_playing_index].max_view_per_session =
          parseInt(temp_banner_data[top_banner_playing_index].max_view_per_session) - 1;
      } else {
        //console.log('removed by calculation');
        try {
          temp_banner_data.splice(top_banner_playing_index, 1);
        } catch (error) {
          //////console.log(error)
        }
      }

      let temp_separate_data = '';
      temp_separate_data = separate_data;

      switch (type) {
        case TARGET_TYPE_FIXED:
          temp_separate_data.top_banner_fixed_data =
            temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
          break;
        case TARGET_TYPE_FILLER:
          temp_separate_data.top_banner_filler_data =
            temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
          break;
        case TARGET_TYPE_FLOATING:
          temp_separate_data.top_banner_floating_data =
            temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
          break;
        default:
          //bannerUtils.log("type null")
          break;
      }

      let temp_local_data = sessionStorage.getItem(bannerLocalConstant.GLOBAL_BANNER_DATA);
      temp_local_data = temp_local_data ? JSON.parse(temp_local_data) : '';

      // ////console.group("data sync with local")
      if (
        typeof temp_local_data == 'object' &&
        typeof temp_local_data.global_banner_data == 'object'
      ) {
        switch (position) {
          case bannerLocalConstant.BANNER_POSITION_INTERSTITIAL:
            temp_local_data.global_banner_data.top_banner_data = [
              ...temp_separate_data.top_banner_fixed_data,
              ...temp_separate_data.top_banner_floating_data,
              ...temp_separate_data.top_banner_filler_data
            ];
            break;

          default:
            break;
        }

        if (
          content_id &&
          content_id != 0 &&
          content_banner_main_data &&
          typeof content_banner_main_data == 'object'
        ) {
        } else {
          sessionStorage.setItem(
            bannerLocalConstant.GLOBAL_BANNER_DATA,
            JSON.stringify(temp_local_data)
          );
        }
      } else {
        bannerUtils.log('not set on local');
      }

      setPriorityList(temp_separate_data);
      set_separate_data(temp_separate_data);
    } else {
      bannerUtils.log('banner data----------------');
    }
    // //bannerUtils.log("exit done ")
  };

  // const checkCreativeAvailable = (_data = []) => {
  //   let temp_banner_data = _data;
  //   if (
  //     temp_banner_data &&
  //     temp_banner_data?.length > 0 &&
  //     !_search(temp_banner_data[_playing_index_ref.current]?.items, banner_setting)[0]?.file
  //   ) {
  //     let type = temp_banner_data[_playing_index_ref.current]?.target_type;
  //     // let { target_type } = temp_banner_data[_playing_index_ref.current];
  //     temp_banner_data = _data.splice(_playing_index_ref.current, 1);

  //     let temp_separate_data = '';
  //     temp_separate_data = separate_data;

  //     switch (type) {
  //       case TARGET_TYPE_FIXED:
  //         temp_separate_data.top_banner_fixed_data =
  //           temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
  //         break;
  //       case TARGET_TYPE_FILLER:
  //         temp_separate_data.top_banner_filler_data =
  //           temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
  //         break;
  //       case TARGET_TYPE_FLOATING:
  //         temp_separate_data.top_banner_floating_data =
  //           temp_banner_data && temp_banner_data?.length > 0 ? temp_banner_data : [];
  //         break;
  //       default:
  //         //bannerUtils.log("type null")
  //         break;
  //     }

  //     setPriorityList(temp_separate_data);
  //     set_separate_data(temp_separate_data);
  //     return false;
  //   } else {
  //     return true;
  //   }
  // };

  const onBannerClick = (data = [], ind = '') => {
    // //alert("cta" + data[ind].items[0].CTA)
    if (!data || data?.length < 0 || ind < 0) return false;
    let temp_click_report = {
      campaign_id: data[ind]?.campaign_id ? data[ind]?.campaign_id : 0,
      content_type: page_name ? page_name : 'not found',
      content_type_id: content_id ?? 0,
      banner_position: position,
      creative_id: temp_creative_id ? temp_creative_id : 0
    };
    dispatch(
      addBannerClickReport(temp_click_report, (response) => {
        ////console.log("click report added")
      })
    );
    if (data?.length > 0 && data[ind]?.items[0]?.CTA) {
      ////console.log("banner data click" + data[ind].items[0].CTA)
      switch (data[ind]?.items[0]?.CTA) {
        case 'external_url':
          ////console.log("this is external")
          if (data[ind]?.items[0]?.external_URL) {
            bannerUtils.openNewTab(data[ind]?.items[0].external_URL, _TARGET_BLANK);
          }
          break;
        case 'internal_url':
          ////console.log("this is internal")
          if (data[ind]?.items[0]?.internal_type) {
            let redirectUrl = '';
            if (
              data[ind]?.items[0]?.internal_type_id &&
              data[ind]?.items[0]?.internal_type_id != 0
            ) {
              redirectTo(data[ind]?.items[0]?.internal_type, data[ind]?.items[0]?.internal_type_id);
            } else {
              redirectTo(data[ind]?.items[0]?.internal_type);
            }
          }
          break;
        case 'file_download':
          ////console.log("this is file download")
          if (data[ind]?.items[0]?.CTAupload_file) {
            downloadFromUrl(data[ind]?.items[0]?.CTAupload_file);
          }
          break;
        case 'pdf_open':
          ////console.log("this is pdf open   ")
          if (data[ind]?.items[0]?.CTAupload_file) {
            bannerUtils.openNewTab(data[ind]?.items[0]?.CTAupload_file, _TARGET_BLANK);
            // set_cta_url(data[ind].CTAupload_file);
            // set_cta_target(_TARGET_BLANK)
          }
          break;
        default:
          //////console.log("no cta found-----☹☹😲")
          break;
      }
    } else {
      return false;
    }
  };

  const downloadFromUrl = (remote_url = '') => {
    fetch(remote_url).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = 'clirnet_file';
        a.click();
      });
    });
  };
  function _search(arr = [], term = '') {
    return arr.filter((key) => key.creative_dimension == term);
  }

  // let _playing_item = () => top_banner_playing_item?.length > 0 &&
  //     top_banner_playing_index > 0 ?
  //     _search(top_banner_playing_item[top_banner_playing_index].items, banner_setting, "playing item") : [];

  // const creative_dimention = banner_setting && is_banner_allowed && _search(top_banner_playing_item[top_banner_playing_index].items, banner_setting)?.length > 0 ? banner_setting.split('x') : [0, 0];
  // //console.table(top_banner_playing_item)

  const setCreativeId = () => {
    temp_creative_id =
      _search(top_banner_playing_item[top_banner_playing_index]?.items, banner_setting)?.length >
      0 &&
      _search(top_banner_playing_item[top_banner_playing_index]?.items, banner_setting)[0]
        .creative_id;
  };

  const setBannerStyle = (_height = 0, _width = 0) => {
    if (_height > 0 && _width > 0) {
      let auto_height = window_width * (_height / _width);
      return {
        height: `${isMobile ? auto_height : _height}px`,
        width: `${isMobile ? window_width : _width}px`,
        cursor: 'pointer'
      };
    } else {
      return { height: `0px`, width: `0px`, cursor: 'pointer' };
    }
  };
  // { height: `${banner_setting.split('x')[1]}px`, width: `${banner_setting.split('x')[0]}px`, cursor: 'pointer' }

  const getBannerClass = () => {
    let tempClass = '';
    if (
      banner_setting &&
      is_banner_allowed &&
      top_banner_playing_index >= 0 &&
      top_banner_playing_item?.length > 0 &&
      _search(top_banner_playing_item[top_banner_playing_index]?.items, banner_setting)?.length > 0
    ) {
      if (position == 'top') {
        tempClass = 'mt-4 mb-4';
      } else if (position == 'bottom') {
        tempClass = 'mb-4 mt-4';
      } else if (position == 'side-top') {
        tempClass = 'mb-4';
      } else if (position == 'side-bottom') {
        tempClass = 'mt-4 mb-4';
      } else if (position == 'section-header') {
        tempClass = 'mt-4 mb-4';
      }
    }
    return tempClass;
  };

  const setBannerContainerClass = () => {
    // {position == "top" || position == "bottom" ? `w-100 text-center ${getBannerClass()}` : `w-100 text-center ${getBannerClass()}`}
    if (position == 'top') {
      return `d-inline-block position-relative text-right banner_size_adjust`;
    } else if (position == 'bottom') {
      return `d-inline-block position-relative  mt-3 text-right banner_size_adjust`;
    } else if (position == 'side-top') {
      return `d-inline-block position-relative  mt-3 text-right`;
    } else if (position == 'side-bottom') {
      return `d-inline-block position-relative  mt-3 text-right`;
    } else if (position == 'section-header') {
      return 'd-inline-block position-relative text-right banner_size_adjust';
    } else {
      return '';
    }
  };

  function getModifiedImageUrl() {
    let url = _search(top_banner_playing_item[top_banner_playing_index]?.items, banner_setting)[0]
      .file;

    let transformation = ''; //`?tr=pr=true,c-at_max`;
    // console.log('inside video banner player', transformation, url);
    if (url && typeof url == 'string' && !url.includes('https')) {
      let splittedImg = url?.split('/');
      let path_extracted_image = splittedImg[splittedImg?.length - 1];
      const cfImageUrl = `https://bnr-cdn.clirnet.com/${path_extracted_image}${transformation}`;
      // console.log('inside video banner player in if', path_extracted_image, cfImageUrl);
      return cfImageUrl;
    } else if (
      url &&
      typeof url == 'string' &&
      url.includes('https://storage.googleapis.com/medwiki')
    ) {
      const temp_image_name = url.replace('https://storage.googleapis.com/medwiki/', '');
      const cfImageUrl = `https://bnr-cdn.clirnet.com/${temp_image_name}${transformation}`;
      // console.log('inside video banner player in else if', temp_image_name, cfImageUrl);
      return cfImageUrl;
    } else {
      console.log('inside video banner player in else ', url);
      return url;
    }
  }

  const onCloseBtnClick = () => {
    dispatch(disableInterstitialAds());
    onBannerChange();
  };

  return (
    show_ads && is_eligible && isCampaignAvailable ? <div className={customClass ? customClass : 'w-100'}>
      <Modal
        className="interstitialModal"
        size="md"
        centered
        show={show_ads && is_eligible && isCampaignAvailable}
      >
        <Modal.Body>
          {showCloseBtn && !showContinueBtn && (
            <div
              className="bannerCloseBtn bg-white text-black fs-16 fw-medium "
              onClick={onCloseBtnClick}
            >
              <GrClose customClass={'fs-4 text-black'} />
            </div>
          )}
          {!showCloseBtn &&
            isCampaignAvailable &&
            !showContinueBtn &&
            banner_setting &&
            is_banner_allowed &&
            top_banner_playing_index >= 0 &&
            top_banner_playing_item?.length > 0 && (
              <div className="bannerCloseBtn bg-white text-black fs-16 fw-medium">
                <span>
                  {Math.abs(
                    parseInt(top_banner_playing_item[top_banner_playing_index].duration) -
                    parseInt(_video_duration_ref.current)
                  )}
                </span>
              </div>
            )}

          <section
            className={'w-100 text-center d-flex flex-column '}
            id={`${position}_ads`}
            ref={topBannerContainer}
          >
            {/* {banner_setting &&
            is_banner_allowed &&
            top_banner_playing_index >= 0 &&
            top_banner_playing_item?.length > 0 &&
            //  !top_banner_playing_item[top_banner_playing_index].isSkipButton &&
            !showCloseBtn ? ( */}

            {/* ) : null} */}
            {banner_setting &&
              is_banner_allowed &&
              top_banner_playing_index >= 0 &&
              top_banner_playing_item?.length > 0 && (
                <div
                  className={`bannerContainer position-relative ${setBannerContainerClass()}`}
                  title={
                    _search(
                      top_banner_playing_item[top_banner_playing_index]?.items,
                      banner_setting
                    )[0]?.CTA_text ?? 'Sponsored Ad'
                  }
                  onClick={() => onBannerClick(top_banner_playing_item, top_banner_playing_index)}
                  style={{ cursor: 'pointer' }}
                // style={setBannerStyle(banner_setting.split('x')[1], banner_setting.split('x')[0])}
                >
                  <>
                    {banner_setting &&
                      is_banner_allowed &&
                      top_banner_playing_index >= 0 &&
                      top_banner_playing_item?.length > 0 && (
                        <>
                          {setCreativeId()}
                          {_search(
                            top_banner_playing_item[top_banner_playing_index]?.items,
                            banner_setting
                          )?.length > 0 &&
                            _search(
                              top_banner_playing_item[top_banner_playing_index]?.items,
                              banner_setting
                            )[0].type == 'video' && (
                              <ReactPlayer
                                ref={topBannerPlayerRef}
                                width={'100%'}
                                height={'100%'}
                                muted={true}
                                playsinline={true}
                                controls={false}
                                playing={videoPlay}
                                url={getModifiedImageUrl()}
                                onEnded={onBannerChange}
                                onError={(e) => console.log('onError', e)}
                                onProgress={(e) => {
                                  set_video_duration(e.playedSeconds);
                                  _video_duration_ref.current = e.playedSeconds;
                                }}
                              />
                            )}
                          {_search(
                            top_banner_playing_item[top_banner_playing_index]?.items,
                            banner_setting
                          )?.length > 0 &&
                            _search(
                              top_banner_playing_item[top_banner_playing_index]?.items,
                              banner_setting
                            )[0].type == 'image' && (
                              <ImageBannerPlayer
                                url={
                                  _search(
                                    top_banner_playing_item[top_banner_playing_index]?.items,
                                    banner_setting
                                  )[0].file
                                }
                                seconds={
                                  top_banner_playing_item[top_banner_playing_index].duration
                                    ? top_banner_playing_item[top_banner_playing_index].duration
                                    : 2
                                }
                                playing={!videoPlay}
                                onEnded={onImageViewEnd}
                                onDuration={handleDuration}
                              />
                            )}
                        </>
                      )}
                  </>
                </div>
              )}

            {!showCloseBtn && showContinueBtn && (
              <div className="continueReading">
                <a
                  href="javascript:void(0)"
                  className="btn btn-primary fs-4 fw-medium rippleEffect cursorPointer rounded"
                  onClick={onCloseBtnClick}
                >
                  {' '}
                  Skip
                </a>
              </div>
            )}
          </section>
        </Modal.Body>
      </Modal>
    </div> : <></>
  );
};

BannerItem.propTypes = {
  position: PropTypes.string.isRequired,
  page_name: PropTypes.string.isRequired
};

export default memo(BannerItem);
